<template>
  <!-- Select -->
  <b-form-select
    class="dynamic-select"
    :name="field.name"
    v-if="!viewMode"
    v-model="localValue"
    :options="field.options"
    :required="field.required"
    :value="fieldValue"
    v-on:input="updateValue($event)"
    size="sm"
  >
  </b-form-select>
  <dynamicform-input-text
    v-else-if="viewMode"
    :entity="entity"
    :fieldValue="fieldValue"
    :field="field"
    :viewMode="viewMode"
  >
  </dynamicform-input-text>
</template>

<script>
export default {
  name: "DynamicformSelect",
  props: {
    field: {
      type: Object,
      default: null,
    },
    entity: {
      type: Object,
      default: null,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    fieldValue: {
      type: [String,Number],
      default: null,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      localValue: this.$props.fieldValue,
    };
  },
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/_variables.scss";

.dynamic-select {
  height: $form-component-height;
  border-radius: 3px;
  border: 1px solid $gray-300;
  color: $gray-550;
  background: #fff
    url("data:image/svg+xml;utf8,<svg width='1em' height='1em' role='img' xmlns='http://www.w3.org/2000/svg' fill='979797'><path d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'></path></svg>")
    no-repeat right 0.75rem center;
  background-size: 20px;

  &::after {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DynamicForms/Select.vue